module.exports = __webpack_public_path__ + "img/tks_hk.1824f359.png";